import React from "react";

interface SkeletonProps {
  className?: string;
}

const Skeleton = ({ className = "" }: SkeletonProps) => (
  <div className={`animate-pulse bg-[#2a2e35a8] ${className}`} />
);

export default Skeleton;
